import { Modal } from "react-bootstrap";
import backIcon from "../../../../images/arrow-left-solid.png";
import plusIcon from "../../../../images/plus-solid.png";
import checkIcon from "../../../../images/check-solid.png";
import ErrorAlert from "../../../../common/ui/ErrorAlert";
import * as CommonUtilities from "../../../../common/utils/CommonUtils";

export default function ItemVoucherParentPage(props) {
    let voucherDetails = props.loyaltyMember.VoucherDetails;

    // Map Voucher Group Buttons
    let voucherGroupButtons = voucherDetails.FormData.VoucherGroups.map((group) => {
        let buttonImageToDisplay;
        let productTextDisplay;
        let hasErrorClass = group.HasError ? "is-invalid border-danger" : "";
        let modifiersToDisplay, modifierDisplayContainer;
        let chargePriceForMods = group.ChargePriceForMods;
        let priceIncModDisplay, priceIncMod;

        if (group.ProductID == '' || group.ProductID == null) {
            productTextDisplay = `Choose ${group.GroupName}`;
            buttonImageToDisplay = <span className="bg-dark rounded-pill d-flex align-items-center justify-content-center" style={{width: "20px", height: "20px", minWidth: "20px"}}><img src={plusIcon} alt="Add" title="Add" style={{width: "10px"}}></img></span>
        } else {
            productTextDisplay = `${group.ProductName}`;
            buttonImageToDisplay = <span className="bg-success rounded-pill d-flex align-items-center justify-content-center" style={{width: "20px", height: "20px", minWidth: "20px"}}><img src={checkIcon} alt="Selected" style={{width: "10px"}}></img></span>

            // Display Modifiers
            if (group.Mods.length > 0) {
                modifiersToDisplay = group.Mods.map((mod) => {
                    if (chargePriceForMods) {
                        priceIncMod = CommonUtilities.formatDisplayPrice(mod.PriceInc);
                        priceIncModDisplay = <span className="ms-2 ps-1">{priceIncMod}</span>
                    } else {
                        priceIncMod = '';
                        priceIncModDisplay = <></>
                    }
                    
                    return <li key={mod.PLU}>{mod.ModName}{priceIncModDisplay}</li>
                })
                modifierDisplayContainer = 
                    <small className="text-muted">
                        <ul className="mb-0">
                            {modifiersToDisplay}
                        </ul>
                    </small>
            } else {
                modifierDisplayContainer = <></>;
            }

        }
        return (
            <div key={group.KeyForElement}>
                <div className="col-12">
                    <hr className="text-body-tertiary"/>
                </div>
                <div className="col-12 pb-2">                
                    <b>{group.GroupName}</b>
                </div>
                <div className="col-12 py-2 d-grid">
                    <button type="button" className={`btn btn-light border d-flex flex-row justify-content-start align-items-center py-3 ${hasErrorClass}`} onClick={props.handleSelectGroupItemVoucherParent} data-indexvouchergroup={group.KeyForElement} disabled={props.loyaltyMember.ItemVoucherParentPage.GeneralError.ButtonsDisabled} >
                        {buttonImageToDisplay}
                        &emsp;<div className="d-flex flex-column align-items-start text-start text-break">
                            <span>{productTextDisplay}</span>
                            {modifierDisplayContainer}
                        </div>
                    </button>
                    <div className="invalid-feedback">{group.ErrorMessage}</div>
                </div>
            </div>
        )
    });

    return (
        <>
            <div className="modal-header justify-content-start text-break">
                <button type="button" className="btn btn-light rounded-pill" onClick={props.handleBackItemVoucherParent} disabled={props.loyaltyMember.ItemVoucherParentPage.GeneralError.ButtonsDisabled}>
                    <img src={backIcon} alt="Back" title="Back" style={{width: "20px"}}></img>
                </button>
                <h1 className="modal-title fs-5">&emsp;Select Voucher Details</h1>
                <button type="button" className="btn-close" aria-label="Close" onClick={props.handleClickCloseLoyaltyModal}></button>
            </div>
            <Modal.Body>
                <div><b>{voucherDetails.OriginalData.nameExternal}</b></div>
                <div>{voucherDetails.OriginalData.descriptionExternal}</div>
                {voucherGroupButtons}
            </Modal.Body>
            <Modal.Footer>
                { props.loyaltyMember.ItemVoucherParentPage.GeneralError.HasError && <div className="px-1 mx-auto mb-3 col-12"><ErrorAlert message={props.loyaltyMember.ItemVoucherParentPage.GeneralError.ErrorMessage} /></div> }
                { props.currentLocation.AllowOnlineOrder && props.currentLocation.Validation.IsValidTableNumber &&
                <div className="col-12 d-flex justify-content-center mx-auto">
                    <button type="button" className="btn btn-dark rounded-pill px-5" onClick={props.handleAddVoucherToCartItemVoucherParent} disabled={props.loyaltyMember.ItemVoucherParentPage.GeneralError.ButtonsDisabled} >
                        Add Voucher to Cart
                        { props.loyaltyMember.ItemVoucherParentPage.GeneralError.ButtonsDisabled && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></>}
                    </button>
                </div>}
            </Modal.Footer>
        </>
    )
}